/**
 * Single source of truth for Bricolat's social media profiles.
 * Reused by the UI (SocialLinks, footer, home, contact) and SEO (SchemaOrg `sameAs`).
 *
 * Can be overridden in production via the existing `VITE_SOCIAL_PROFILES` env var
 * (comma-separated full URLs). If a matching network URL is found there, it wins;
 * otherwise we fall back to the canonical URLs below.
 */

const DEFAULT_INSTAGRAM_URL = 'https://www.instagram.com/bricolatma/';
const DEFAULT_FACEBOOK_URL = 'https://www.facebook.com/bricolatma';

const envProfiles: string[] = (import.meta.env.VITE_SOCIAL_PROFILES || '')
    .split(',')
    .map((url: string) => url.trim())
    .filter(Boolean);

const findEnvUrl = (...needles: string[]): string | undefined =>
    envProfiles.find((url) => needles.some((n) => url.toLowerCase().includes(n)));

export const SOCIAL = {
    instagram: {
        url: findEnvUrl('instagram.com') || DEFAULT_INSTAGRAM_URL,
        handle: '@bricolatma',
    },
    facebook: {
        url: findEnvUrl('facebook.com', 'fb.com') || DEFAULT_FACEBOOK_URL,
    },
} as const;

/** All social profile URLs (for SEO `sameAs`). */
export const SOCIAL_PROFILE_URLS: string[] = [SOCIAL.instagram.url, SOCIAL.facebook.url];

export type SocialNetwork = keyof typeof SOCIAL;
